module.exports = __webpack_public_path__ + "media/tech.098640ef.mp3";